(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crux-aura-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tunePagination = (section) => {
      if (section.dataset.cruxPaginationReady === 'true') return;

      let attempts = 0;
      let phase = 'open-second';

      const apply = () => {
        const widget = section.querySelector('.jdgm-rev-widg');
        const paginator = section.querySelector('.jdgm-paginate');

        if (!widget || !paginator) {
          attempts += 1;
          if (attempts < 24) window.setTimeout(apply, 300);
          return;
        }

        const total = Number(widget.dataset.numberOfReviews || 0);
        const expected = Math.min(6, total);
        const visibleReviews = section.querySelectorAll('.jdgm-rev').length;
        const currentPage = paginator.querySelector('.jdgm-curt')?.dataset.page;
        paginator.dataset.perPage = '6';

        if (total <= 5 || visibleReviews === expected) {
          section.dataset.cruxPaginationReady = 'true';
          return;
        }

        attempts += 1;
        if (attempts > 12) {
          section.dataset.cruxPaginationReady = 'true';
          return;
        }

        if (phase === 'open-second') {
          const secondPage = paginator.querySelector(
            '.jdgm-paginate__page[data-page="2"]:not(.jdgm-paginate__next-page):not(.jdgm-paginate__last-page)'
          );

          if (secondPage) {
            phase = 'return-first';
            secondPage.click();
          }
        } else if (currentPage === '2' || visibleReviews !== 5) {
          const firstPage = paginator.querySelector(
            '.jdgm-paginate__page[data-page="1"]:not(.jdgm-paginate__first-page):not(.jdgm-paginate__prev-page)'
          );

          if (firstPage) firstPage.click();
        }

        window.setTimeout(apply, 650);
      };

      window.setTimeout(apply, 500);
    };

    const initialize = (root = document) => {
      root.querySelectorAll('.crux-aura-product-reviews').forEach(tunePagination);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crux-aura-shop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPlacementPreview = (scope = document) => {
      scope.querySelectorAll('[data-crux-aura-placement]').forEach((component) => {
        if (component.dataset.placementPreviewReady === 'true') return;
        component.dataset.placementPreviewReady = 'true';

        const options = [...component.querySelectorAll('[data-placement-option]')];
        const target = component.querySelector('[data-placement-target]');
        const image = component.querySelector('[data-placement-image]');
        if (!options.length || !target || !image) return;

        let switchTimer;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const activate = (option) => {
          const nextSrc = option.dataset.placementSrc;
          if (!nextSrc) return;

          options.forEach((item) => item.classList.toggle('is-active', item === option));
          target.href = option.href;
          target.setAttribute('aria-label', 'Shop ' + option.dataset.placementLabel.toLowerCase() + ' placement');

          window.clearTimeout(switchTimer);
          image.classList.add('is-switching');
          switchTimer = window.setTimeout(() => {
            image.srcset = option.dataset.placementSrcset || '';
            image.src = nextSrc;
            image.alt = option.dataset.placementAlt || option.dataset.placementLabel + ' piercing jewelry';
            window.requestAnimationFrame(() => image.classList.remove('is-switching'));
          }, reducedMotion.matches ? 0 : 90);
        };

        options.forEach((option) => {
          option.addEventListener('pointerenter', () => {
            const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
            if (supportsHover) activate(option);
          });
          option.addEventListener('focus', () => {
            window.requestAnimationFrame(() => {
              if (option.matches(':focus-visible')) activate(option);
            });
          });
          option.addEventListener('click', (event) => {
            const isTouchInteraction = window.matchMedia('(hover: none), (pointer: coarse)').matches;
            if (isTouchInteraction && !option.classList.contains('is-active')) {
              event.preventDefault();
              activate(option);
            }
          });
        });

        const preload = () => {
          options.slice(1).forEach((option) => {
            if (!option.dataset.placementSrc) return;
            const preloadImage = new Image();
            preloadImage.srcset = option.dataset.placementSrcset || '';
            preloadImage.src = option.dataset.placementSrc;
          });
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preload, { timeout: 2500 });
        } else {
          window.setTimeout(preload, 1200);
        }
      });
    };


    const initGemstoneVideo = (scope = document) => {
      scope.querySelectorAll('[data-crux-aura-gemstones]').forEach((component) => {
        if (component.dataset.gemstoneVideoReady === 'true') return;
        component.dataset.gemstoneVideoReady = 'true';
        const video = component.querySelector('[data-aura-gemstone-video]');
        const toggle = component.querySelector('[data-aura-gemstone-video-toggle]');
        const icon = component.querySelector('[data-aura-gemstone-video-icon]');
        if (!video || !toggle || !icon) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let userPaused = reducedMotion.matches;
        let inView = false;

        const sync = () => {
          const paused = video.paused;
          icon.textContent = paused ? '▶' : 'Ⅱ';
          toggle.setAttribute('aria-label', paused ? 'Play Moissanite video' : 'Pause Moissanite video');
        };
        const play = () => video.play().then(sync).catch(sync);
        const updatePlayback = () => {
          if (userPaused || reducedMotion.matches || !inView) video.pause();
          else play();
          sync();
        };

        toggle.addEventListener('click', () => {
          userPaused = !video.paused;
          if (video.paused) {
            userPaused = false;
            play();
          } else {
            userPaused = true;
            video.pause();
          }
          sync();
        });
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            inView = entries.some((entry) => entry.isIntersecting);
            updatePlayback();
          }, { threshold: 0.35 });
          observer.observe(component);
        } else {
          inView = true;
          updatePlayback();
        }
        sync();
      });
    };

    initGemstoneVideo();
    document.addEventListener('shopify:section:load', (event) => initGemstoneVideo(event.target));
    initPlacementPreview();
    document.addEventListener('shopify:section:load', (event) => initPlacementPreview(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
